export enum DestinationType {
  CITY = 'CITY', COUNTRY = 'COUNTRY', HOTEL = 'HOTEL'
}
